(function (upp) {
    'use strict';
    upp
        .config(['$routeProvider',
        function ($routeProvider) {
            $routeProvider
            .when('/account/orders', {
            	templateUrl: require('../templates/orders.html'),
            	showAd:true
            });
        }])
    ;

})(upp);


// WEBPACK FOOTER //
// ./src/app/plugins/orders/routes/orders-routes.js